import { createElement, memo, useCallback, useContext } from '@max/max';
import View from '@hfe/max-view';
import LImage from '@max/leez-image';
import Text from '@hfe/max-text';
import { getImageUrl } from '../../../lib/utils/imageUtils';
import './index.scss';
import { navigateTo } from '@max/meituan-uni-navigate';
import { getFlightOTAUrl } from '../../../lib/redirect';
import { PlatformType, SystemType } from '@nibfe/mkt-env-api';
import { getPlatformType, getSystemType } from '@nibfe/mkt-env-api';
import { CLICK_CARD_MC_BID, isdpHost } from '../../../lib/constant';
import qs from 'querystring';
const isMRN = false;
import LinearGradient from '@hfe/max-linear-gradient';
const platformType = getPlatformType();
const systemType = getSystemType();
const week = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
const FlightTheme7 = (props) => {
    var _a, _b;
    const isAndroid = systemType === 'android';
    const ctx = useContext(global._EngineGlobalContext);
    const formatterDay = useCallback((date, t) => {
        const y = date.substr(0, 4);
        const m = date.substr(5, 2);
        const d = date.substr(8, 2);
        if (t === 'time') {
            return new Date(Number(y), Number(m) - 1, Number(d)).getTime() / 1000; // 精确到秒
        }
        if (props.routeConfig_recommendType === 4) {
            return m + '月' + d + '日';
        }
        else {
            return m + '月' + d + '日 ' + week[new Date(Number(y), Number(m) - 1, Number(d)).getDay()];
        }
    }, [props.routeConfig_recommendType]);
    const formatDayDescription = useCallback((item) => {
        if (props.routeConfig_recommendType === 4) {
            return formatterDay(item.date) + ' ' + item.departTime + '出发' + '  ' + item.flightNumber + '航班';
        }
        else {
            return formatterDay(item.date);
        }
    }, [props.routeConfig_recommendType]);
    const jump = useCallback((item, index) => {
        var _a, _b;
        let lab = {
            departCityCode: item.departCityCode,
            arriveCityCode: item.arriveCityCode,
            departuredate: item.date,
            price: item.price,
            line: index + 1,
            custom: {
                component_name: '机票往返特价组件',
                bu_code: 'traffic',
                // 区分业务BU，按实际业务上报
                depart_city_name: item.departCityName,
                arrive_city_name: item.arriveCityName
            }
        };
        (_b = (_a = ctx._LXReport) === null || _a === void 0 ? void 0 : _a.mcReport) === null || _b === void 0 ? void 0 : _b.call(_a, CLICK_CARD_MC_BID, {
            valLab: lab
        });
        if (props.routeConfig_recommendType === 4) {
            navigateTo({
                url: getFlightOTAUrl(item)
            });
        }
        else {
            const mtUrl = 'imeituan://www.meituan.com/flight/flight_list?';
            const dpUrl = 'dianping://www.dianping.com/flight/flight_list?';
            const date = new Date(item.date).getTime() / 1000;
            const search = {
                goDate: date,
                departCityName: item.departCityName,
                arriveCityName: item.arriveCityName,
                trafficsource: props.sourceSwitch || '',
                arriveCode: item.arriveCityCode,
                departCode: item.departCityCode,
                departCity: '',
                arriveCity: '',
                mode: 0,
                extendData: item.extendData ? JSON.stringify(item.extendData) : '',
                activityUIIndex: '7',
                targetFlightNo: item.flightNumber,
                originPrice: item.price,
                tagContent: props.cornerLabelWord,
                sortType: '5'
            };
            let url = mtUrl + 'param=' + encodeURIComponent(JSON.stringify(search));
            try {
                if (systemType === SystemType.android) {
                    if ([PlatformType.mtApp, PlatformType.mtAppWebView].includes(platformType)) {
                        url = mtUrl + 'param=' + encodeURIComponent(JSON.stringify(search));
                    }
                    else if ([PlatformType.dpApp, PlatformType.dpAppWebView].includes(platformType)) {
                        url = dpUrl + qs.stringify(search);
                    }
                    else {
                        if (isdpHost) {
                            url = 'https://w.dianping.com/cube/evoke/dianping.html?url=' + encodeURIComponent(dpUrl + qs.stringify(search));
                        }
                        else {
                            url = 'https://m.dianping.com/cube/evoke/train/meituan.html?url=' + encodeURIComponent(mtUrl + 'param=' + encodeURIComponent(JSON.stringify(search)));
                        }
                    }
                }
                else if (systemType === SystemType.ios) {
                    if ([PlatformType.mtApp, PlatformType.mtAppWebView].includes(platformType)) {
                        url = mtUrl + 'param=' + encodeURIComponent(JSON.stringify(search));
                    }
                    else if ([PlatformType.dpApp, PlatformType.dpAppWebView].includes(platformType)) {
                        url = mtUrl + qs.stringify(search); //历史遗留问题，点评iOS跳转imeituan协议
                    }
                    else {
                        if (isdpHost) {
                            // 增加中转页面
                            url = 'https://w.dianping.com/cube/evoke/dianping.html?url=' + encodeURIComponent('https://m.dianping.com/awp/hfe/block/3620f5299cd2/103644/index.html?' + qs.stringify(search));
                        }
                        else {
                            url = 'https://m.dianping.com/cube/evoke/train/meituan.html?url=' + encodeURIComponent(mtUrl + 'param=' + encodeURIComponent(JSON.stringify(search)));
                        }
                    }
                }
                else {
                    // 按需求进行鸿蒙系统跳链调整
                    if ([PlatformType.mtApp, PlatformType.mtAppWebView].includes(platformType)) {
                        url = mtUrl + 'param=' + encodeURIComponent(JSON.stringify(search));
                    }
                    else if ([PlatformType.dpApp, PlatformType.dpAppWebView].includes(platformType)) {
                        url = dpUrl + qs.stringify(search);
                    }
                    else {
                        if (isdpHost) {
                            url = 'https://w.dianping.com/cube/evoke/dianping.html?url=' + encodeURIComponent(dpUrl + qs.stringify(search));
                        }
                        else {
                            url = 'https://m.dianping.com/cube/evoke/train/meituan.html?url=' + encodeURIComponent(mtUrl + 'param=' + encodeURIComponent(JSON.stringify(search)));
                        }
                    }
                }
                navigateTo({
                    url
                });
            }
            catch (error) {
                console.warn(error);
            }
        }
    }, [(_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo) === null || _a === void 0 ? void 0 : _a.queryParams) === null || _b === void 0 ? void 0 : _b.src, props.sourceSwitch, props.cornerLabelWord, props.routeConfig_recommendType]);
    return <View className="flight-theme-7">
      {props.data.map((item, index) => {
        var _a, _b;
        return <View className='flight-theme-7-container' onClick={() => jump(item, index)} key={index}>
            <View className='flight-theme-7-list' style={{
            marginBottom: index === props.data.length - 1 ? '4rpx' : '12rpx'
        }}>
              <LinearGradient className="flight-theme-7-list-flight-tag" start={{
            x: 0,
            y: 0
        }} end={{
            x: 1,
            y: 1
        }} colors={[(_a = props.cornerConfig) === null || _a === void 0 ? void 0 : _a.cornerTagStartColor, (_b = props.cornerConfig) === null || _b === void 0 ? void 0 : _b.cornerTagEndColor]}>
                <Text className="flight-theme-7-list-tag-text" style={{
            color: props.cornerLabelColor
        }}>{props.cornerLabelWord}</Text>
              </LinearGradient>
              <LImage x-if={props.cornerLabelImg} className="flight-theme-7-list-flight-img" source={{
            uri: getImageUrl(props.cornerLabelImg || '', 66, 0)
        }}/>
              <View className="flight-theme-7-list-flight-city">
                <Text className='flight-theme-7-list-flight-city-flight-city-text'>{item.departCityName}</Text>
                <LImage width={46} style={{
            marginLeft: '10rpx',
            marginRight: '10rpx'
        }} source={{
            uri: 'https://p1.meituan.net/travelcube/09284c2d769dbe030fe47640bd33a4421977.png'
        }}></LImage>
                <Text className='flight-theme-7-list-flight-city-flight-city-text'>{item.arriveCityName}</Text>
              </View>
              <View className="flight-theme-7-list-flight-date">
                <Text className='flight-theme-7-list-flight-date-flight-date-text' style={{
            whiteSpace: 'pre'
        }}>{formatDayDescription(item)}</Text>
              </View>
              <View className="flight-theme-7-list-right">
                <View className="flight-theme-7-list-right-price">
                  <Text className="flight-theme-7-list-right-rmb" style={{
            top: isAndroid ? '-4rpx' : '-2rpx'
        }}>￥</Text>
                  <Text className="flight-theme-7-list-right-num">
                    {item.price}
                  </Text>
                </View>
                <View x-if={item.discout} className='flight-theme-7-list-right-discount-container' style={{
            marginTop: isMRN ? 0 : '6rpx'
        }}>
                  <Text x-if={item.discout === 100} className={['flight-theme-7-list-right-discount', isMRN ? 'discount-mrn' : '']}>全价</Text>
                  <Text x-else className={['flight-theme-7-list-right-discount', isMRN ? 'discount-mrn' : '']}>{item.discout / 10}折</Text>
                </View>
              </View>
            </View>
          </View>;
    })}

    </View>;
};
export default memo(FlightTheme7);
